import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface EditModalContextProps {
  showEditModalQuill: boolean;
  setShowEditModalQuill: (value: boolean) => void;
  card: any;
  setCard : (value : any) => void;
  cardHistory: any[];
  pushToHistory: (card: any) => void;
  goBackInHistory: () => any | null;
  clearHistory: () => void;
  expandedFromSource: boolean;
  setExpandedFromSource: (value: boolean) => void;
}

const EditModalContext = createContext<EditModalContextProps | undefined>(undefined);

export const EditModalProvider: React.FC<{ children: ReactNode }> = ({ children } : {children : React.ReactNode}) : any => {
  const [showEditModalQuill, setShowEditModalQuill] = useState(false);
  const [card, setCard] = useState({})
  const [cardHistory, setCardHistory] = useState<any[]>([])
  const [expandedFromSource, setExpandedFromSource] = useState(false)

  useEffect(()=>{
    return ()=> {
      setCard({})
      setCardHistory([])
    }
  },[])

  const pushToHistory = (cardToPush: any) => {
    if (cardToPush && cardToPush.id) {
      setCardHistory(prev => [...prev, cardToPush])
    }
  }

  const goBackInHistory = () => {
    if (cardHistory.length > 0) {
      const previousCard = cardHistory[cardHistory.length - 1]
      setCardHistory(prev => prev.slice(0, -1))
      return previousCard
    }
    return null
  }

  const clearHistory = () => {
    setCardHistory([])
  }

  return (
    <EditModalContext.Provider value={{ showEditModalQuill, setShowEditModalQuill, card, setCard, cardHistory, pushToHistory, goBackInHistory, clearHistory, expandedFromSource, setExpandedFromSource }}>
      {children}
    </EditModalContext.Provider>
  );
};

export const useEditModal = () : EditModalContextProps  => {
  const context  = useContext(EditModalContext);
  if (!context) {
    throw new Error('useEditModal must be used within an EditModalProvider');
  }
  return context;
};
